import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { Container, Typography, Box, Grid, Button } from '@mui/material';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(6, 0),
    backgroundColor: '#FFFFFF',
    maxWidth:'1200px'
  },
  card: {
    backgroundColor: '#F8FAFD',
    borderRadius: '16px',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0 1px 4px rgba(0,0,0,0.06)',
    marginBottom: theme.spacing(3),
    minHeight: 'auto',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      minHeight: '260px',
    },
  },
  cardImg: {
    backgroundColor: '#E8F0FB',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    width: '100%',
    height: '200px',
    flexShrink: 0,
    [theme.breakpoints.up('md')]: {
      width: '380px',
      height: 'auto',
    },
    '& img, & svg': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  cardContent: {
    padding: theme.spacing(3, 3),
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    [theme.breakpoints.up('md')]: {
      padding: theme.spacing(4, 5),
    },
  },
  cardTitleRow: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  cardIcon: {
    flexShrink: 0,
    width: '48px',
    height: '48px',
    backgroundColor: '#DCE8FB',
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& svg': {
      width: '24px',
      height: '24px',
      color: '#2152D9',
    },
  },
  cardTitle: {
    fontSize: '1.25rem',
    fontWeight: 700,
    color: '#111827',
    lineHeight: 1.3,
    [theme.breakpoints.up('md')]: {
      fontSize: '1.375rem',
    },
  },
  cardBody: {
    '& p': {
      fontSize: '0.9375rem',
      color: '#4B5563',
      lineHeight: 1.7,
      marginBottom: theme.spacing(1.5),
      '&:last-child': {
        marginBottom: 0,
      },
    },
  },
  bottomBanner: {
    backgroundColor: '#1A2F7A',
    borderRadius: '14px',
    padding: theme.spacing(4, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(3),
    marginTop: theme.spacing(4),
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      padding: theme.spacing(4, 5.5),
    },
  },
  bannerText: {
    textAlign: 'center',
    [theme.breakpoints.up('md')]: {
      textAlign: 'left',
    },
    '& h3': {
      fontSize: '1.25rem',
      fontWeight: 700,
      color: '#FFFFFF',
      marginBottom: theme.spacing(0.5),
    },
    '& p': {
      fontSize: '0.875rem',
      color: 'rgba(255, 255, 255, 0.75)',
    },
  },
  bannerBtn: {
    backgroundColor: '#F5A623',
    color: '#1A1A2E',
    fontSize: '0.9375rem',
    fontWeight: 700,
    padding: theme.spacing(1.5, 3.5),
    borderRadius: '8px',
    textTransform: 'none',
    whiteSpace: 'nowrap',
    '&:hover': {
      backgroundColor: '#E09510',
    },
  },
}));

const OurPhilosophy = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="lg" className={classes.root}>
      {/* Card 1 */}
      <div className={classes.card}>
        <div className={classes.cardImg}>
          <svg viewBox="0 0 380 260" xmlns="http://www.w3.org/2000/svg">
            <rect width="380" height="260" fill="#b8d8f0"/>
            <ellipse cx="60" cy="55" rx="38" ry="22" fill="white" opacity="0.95"/>
            <ellipse cx="88" cy="45" rx="28" ry="18" fill="white" opacity="0.95"/>
            <ellipse cx="38" cy="48" rx="22" ry="16" fill="white" opacity="0.95"/>
            <ellipse cx="200" cy="40" rx="32" ry="18" fill="white" opacity="0.9"/>
            <ellipse cx="225" cy="32" rx="22" ry="14" fill="white" opacity="0.9"/>
            <ellipse cx="178" cy="35" rx="18" ry="12" fill="white" opacity="0.9"/>
            <ellipse cx="310" cy="55" rx="28" ry="16" fill="white" opacity="0.85"/>
            <ellipse cx="332" cy="46" rx="20" ry="13" fill="white" opacity="0.85"/>
            <rect x="0" y="195" width="380" height="65" fill="#6aaa42"/>
            <rect x="0" y="210" width="380" height="50" fill="#5a9435"/>
            <ellipse cx="190" cy="215" rx="160" ry="8" fill="#8bc665" opacity="0.5"/>
            <rect x="45" y="148" width="14" height="26" rx="4" fill="#e74c4c"/>
            <circle cx="52" cy="138" r="12" fill="#f5c5a0"/>
            <rect x="40" y="127" width="24" height="10" rx="5" fill="#5c3a1e"/>
            <rect x="33" y="150" width="10" height="16" rx="3" fill="#3498db"/>
            <rect x="46" y="174" width="6" height="18" rx="3" fill="#2c3e6e"/>
            <rect x="54" y="174" width="6" height="16" rx="3" fill="#2c3e6e"/>
            <ellipse cx="49" cy="191" rx="5" ry="3" fill="#1a1a1a"/>
            <ellipse cx="57" cy="189" rx="5" ry="3" fill="#1a1a1a"/>
            <line x1="59" y1="156" x2="66" y2="165" stroke="#f5c5a0" strokeWidth="4" strokeLinecap="round"/>
            <rect x="115" y="138" width="18" height="36" rx="5" fill="#c0392b"/>
            <circle cx="124" cy="126" r="14" fill="#f0b090"/>
            <rect x="110" y="113" width="28" height="12" rx="6" fill="#8B4513"/>
            <rect x="120" y="139" width="8" height="6" fill="#f0b090"/>
            <rect x="100" y="140" width="13" height="20" rx="4" fill="#8B4513"/>
            <rect x="116" y="174" width="8" height="22" rx="3" fill="#2c3e6e"/>
            <rect x="126" y="174" width="8" height="20" rx="3" fill="#2c3e6e"/>
            <ellipse cx="120" cy="195" rx="6" ry="4" fill="#1a1a1a"/>
            <ellipse cx="130" cy="193" rx="6" ry="4" fill="#1a1a1a"/>
            <rect x="198" y="128" width="22" height="46" rx="5" fill="#1a2a4a"/>
            <rect x="205" y="128" width="8" height="20" fill="#fff"/>
            <polygon points="208,132 210,132 209,148" fill="#c0392b"/>
            <circle cx="209" cy="116" r="16" fill="#f0b090"/>
            <rect x="193" y="101" width="32" height="13" rx="7" fill="#8B4513"/>
            <rect x="205" y="129" width="8" height="6" fill="#f0b090"/>
            <rect x="226" y="158" width="20" height="14" rx="4" fill="#7f6000"/>
            <rect x="231" y="155" width="10" height="5" rx="2" fill="#7f6000"/>
            <line x1="226" y1="165" x2="246" y2="165" stroke="#a08020" strokeWidth="1.5"/>
            <rect x="199" y="174" width="9" height="24" rx="3" fill="#0d1b36"/>
            <rect x="210" y="174" width="9" height="22" rx="3" fill="#0d1b36"/>
            <ellipse cx="204" cy="197" rx="7" ry="4" fill="#111"/>
            <ellipse cx="215" cy="195" rx="7" ry="4" fill="#111"/>
            <rect x="298" y="140" width="20" height="40" rx="5" fill="#e67e22"/>
            <circle cx="308" cy="128" r="15" fill="#f0b090"/>
            <rect x="293" y="114" width="30" height="12" rx="6" fill="#d0d0d0"/>
            <rect x="293" y="112" width="30" height="8" rx="4" fill="#e8e8e8"/>
            <rect x="304" y="140" width="8" height="6" fill="#f0b090"/>
            <line x1="320" y1="160" x2="325" y2="200" stroke="#8B6914" strokeWidth="4" strokeLinecap="round"/>
            <ellipse cx="322" cy="160" rx="4" ry="3" fill="#6B4F0E"/>
            <rect x="299" y="180" width="8" height="20" rx="3" fill="#d35400"/>
            <rect x="309" y="180" width="8" height="18" rx="3" fill="#d35400"/>
            <ellipse cx="303" cy="199" rx="6" ry="4" fill="#333"/>
            <ellipse cx="313" cy="197" rx="6" ry="4" fill="#333"/>
            <rect x="0" y="215" width="380" height="3" fill="#4a8028" opacity="0.5"/>
          </svg>
        </div>
        <div className={classes.cardContent}>
          <div className={classes.cardTitleRow}>
            <div className={classes.cardIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
            </div>
            <Typography variant="h3" className={classes.cardTitle}>
              Democratize Retirement Planning for All
            </Typography>
          </div>
          <div className={classes.cardBody}>
            <Typography component="p">
              Retirement planning shouldn't be complicated or out of reach. We make it simple, personalized, and accessible—so whether you're just starting your career or nearing retirement, you can confidently plan for the life you want.
            </Typography>
            <Typography component="p">
              We help you understand your current situation, navigate life's changes, and choose the right investments in your 401(k) or 403(b) to work toward a happier future.
            </Typography>
          </div>
        </div>
      </div>

      {/* Card 2 */}
      <div className={classes.card}>
        <div className={classes.cardImg}>
          <svg viewBox="0 0 380 260" xmlns="http://www.w3.org/2000/svg">
            <rect width="380" height="260" fill="#c8dcf4"/>
            <circle cx="30" cy="60" r="22" fill="#f0c830" opacity="0.9"/>
            <text x="22" y="66" fontSize="16" fill="#fff" fontWeight="bold">$</text>
            <circle cx="345" cy="50" r="20" fill="#f0c830" opacity="0.85"/>
            <text x="337" y="56" fontSize="16" fill="#fff" fontWeight="bold">$</text>
            <circle cx="355" cy="140" r="18" fill="#f0c830" opacity="0.8"/>
            <text x="348" y="146" fontSize="14" fill="#fff" fontWeight="bold">$</text>
            <circle cx="25" cy="180" r="16" fill="#f0c830" opacity="0.8"/>
            <text x="18" y="186" fontSize="13" fill="#fff" fontWeight="bold">$</text>
            <rect x="80" y="30" width="210" height="175" rx="16" fill="#fff" opacity="0.95"/>
            <rect x="80" y="30" width="210" height="32" rx="16" fill="#2152d9" opacity="0.9"/>
            <rect x="80" y="46" width="210" height="16" fill="#2152d9" opacity="0.9"/>
            <text x="100" y="52" fontSize="11" fill="#fff" fontWeight="600">401(K)/403(B) PLANS</text>
            <rect x="100" y="100" width="22" height="70" rx="3" fill="#e67e22" opacity="0.85"/>
            <rect x="130" y="80" width="22" height="90" rx="3" fill="#f0c830" opacity="0.85"/>
            <rect x="160" y="115" width="22" height="55" rx="3" fill="#2ecc71" opacity="0.85"/>
            <rect x="190" y="90" width="22" height="80" rx="3" fill="#3498db" opacity="0.85"/>
            <rect x="220" y="105" width="22" height="65" rx="3" fill="#e74c4c" opacity="0.85"/>
            <line x1="95" y1="170" x2="255" y2="170" stroke="#e0e0e0" strokeWidth="1"/>
            <line x1="95" y1="145" x2="255" y2="145" stroke="#e0e0e0" strokeWidth="1"/>
            <line x1="95" y1="120" x2="255" y2="120" stroke="#e0e0e0" strokeWidth="1"/>
            <line x1="95" y1="95" x2="255" y2="95" stroke="#e0e0e0" strokeWidth="1"/>
            <circle cx="240" cy="72" r="18" fill="none" stroke="#3498db" strokeWidth="12" strokeDasharray="75 40"/>
            <circle cx="240" cy="72" r="18" fill="none" stroke="#e74c4c" strokeWidth="12" strokeDasharray="25 90" strokeDashoffset="-75"/>
            <polyline points="130,155 175,100 210,125 265,65" fill="none" stroke="#e74c4c" strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round"/>
            <polygon points="265,65 255,72 270,78" fill="#e74c4c"/>
            <rect x="195" y="68" width="52" height="20" rx="4" fill="#fff" stroke="#ddd" strokeWidth="1"/>
            <text x="199" y="81" fontSize="11" fill="#2152d9" fontWeight="700">134,500</text>
            <rect x="55" y="185" width="50" height="8" rx="4" fill="#5c3a1e"/>
            <rect x="70" y="193" width="8" height="30" rx="4" fill="#5c3a1e"/>
            <rect x="68" y="158" width="48" height="32" rx="4" fill="#1a1a2e"/>
            <rect x="72" y="162" width="40" height="25" rx="2" fill="#2152d9" opacity="0.7"/>
            <rect x="58" y="190" width="68" height="5" rx="2" fill="#0d1117"/>
            <rect x="78" y="140" width="18" height="28" rx="5" fill="#3498db"/>
            <circle cx="87" cy="128" r="12" fill="#f0b090"/>
            <ellipse cx="87" cy="120" rx="13" ry="8" fill="#2c1810"/>
            <rect x="79" y="167" width="7" height="20" rx="3" fill="#2c3e6e"/>
            <rect x="88" y="167" width="7" height="20" rx="3" fill="#2c3e6e"/>
            <ellipse cx="83" cy="186" rx="6" ry="3" fill="#1a1a1a"/>
            <ellipse cx="92" cy="186" rx="6" ry="3" fill="#1a1a1a"/>
            <circle cx="310" cy="100" r="28" fill="#c8dcf4" opacity="0.8" stroke="#a0c0e8" strokeWidth="2"/>
            <circle cx="305" cy="210" r="18" fill="#a0c8f0" opacity="0.6"/>
            <circle cx="340" cy="200" r="12" fill="#b0d0f8" opacity="0.6"/>
          </svg>
        </div>
        <div className={classes.cardContent}>
          <div className={classes.cardTitleRow}>
            <div className={classes.cardIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"></polyline>
                <polyline points="16 7 22 7 22 13"></polyline>
              </svg>
            </div>
            <Typography variant="h3" className={classes.cardTitle}>
              Technology-Enabled, Expert Advice—Without the High Cost
            </Typography>
          </div>
          <div className={classes.cardBody}>
            <Typography component="p">
              We combine the power of technology with financial expertise to deliver accurate, unbiased, and affordable guidance.
            </Typography>
            <Typography component="p">
              By securely connecting your accounts, our algorithms analyze your financial picture and future needs—then recommend the best low-cost investment options available in your employer-sponsored plan.
            </Typography>
          </div>
        </div>
      </div>

      {/* Card 3 */}
      <div className={classes.card}>
        <div className={classes.cardImg}>
          <svg viewBox="0 0 380 260" xmlns="http://www.w3.org/2000/svg">
            <rect width="380" height="260" fill="#c8dcf4"/>
            <rect x="60" y="155" width="200" height="120" rx="8" fill="#1a2a4a"/>
            <rect x="68" y="163" width="184" height="106" rx="5" fill="#2c3e6e"/>
            <rect x="78" y="173" width="80" height="8" rx="2" fill="#3498db" opacity="0.6"/>
            <rect x="78" y="185" width="60" height="6" rx="2" fill="#5dade2" opacity="0.5"/>
            <rect x="78" y="195" width="70" height="6" rx="2" fill="#5dade2" opacity="0.4"/>
            <circle cx="200" cy="190" r="15" fill="#4a6fa5" opacity="0.7"/>
            <rect x="188" y="204" width="24" height="20" rx="4" fill="#4a6fa5" opacity="0.7"/>
            <circle cx="180" cy="218" r="8" fill="#2ecc71" opacity="0.8"/>
            <rect x="177" y="214" width="6" height="8" rx="1" fill="#fff" opacity="0.9"/>
            <text x="85" y="235" fontSize="18" fill="#f0c830">★★★★</text>
            <rect x="50" y="255" width="220" height="10" rx="5" fill="#0d1117"/>
            <path d="M190 30 L270 65 L270 140 Q270 185 190 210 Q110 185 110 140 L110 65 Z" fill="#2152d9" opacity="0.92"/>
            <path d="M190 42 L258 72 L258 140 Q258 178 190 200 Q122 178 122 140 L122 72 Z" fill="#1a3fbf" opacity="0.8"/>
            <polyline points="160,130 182,152 225,108" fill="none" stroke="white" strokeWidth="8" strokeLinecap="round" strokeLinejoin="round"/>
            <rect x="174" y="120" width="32" height="26" rx="6" fill="white" opacity="0.95"/>
            <path d="M180 120 Q180 108 190 108 Q200 108 200 120" fill="none" stroke="white" strokeWidth="5" strokeLinecap="round"/>
            <circle cx="190" cy="133" r="4" fill="#2152d9"/>
            <rect x="188" y="133" width="4" height="6" rx="2" fill="#2152d9"/>
            <path d="M190 30 L270 65 L270 140 Q270 185 190 210 Q110 185 110 140 L110 65 Z" fill="none" stroke="#6ab0ff" strokeWidth="2.5" opacity="0.5"/>
            <rect x="140" y="215" width="100" height="28" rx="6" fill="#2152d9" opacity="0.9"/>
            <text x="163" y="234" fontSize="13" fill="white" fontWeight="700" letterSpacing="1">SECURE</text>
            <circle cx="322" cy="80" r="24" fill="#2152d9" opacity="0.7"/>
            <rect x="312" y="78" width="20" height="16" rx="4" fill="white" opacity="0.9"/>
            <path d="M316 78 Q316 68 322 68 Q328 68 328 78" fill="none" stroke="white" strokeWidth="3.5" strokeLinecap="round"/>
            <rect x="328" y="200" width="18" height="36" rx="3" fill="#5c3a1e"/>
            <ellipse cx="320" cy="195" rx="16" ry="20" fill="#27ae60"/>
            <ellipse cx="337" cy="190" rx="14" ry="18" fill="#2ecc71"/>
            <ellipse cx="329" cy="180" rx="12" ry="16" fill="#27ae60"/>
            <circle cx="355" cy="185" r="16" fill="#2152d9" opacity="0.8"/>
            <rect x="347" y="183" width="16" height="12" rx="3" fill="white" opacity="0.9"/>
            <path d="M350 183 Q350 175 355 175 Q360 175 360 183" fill="none" stroke="white" strokeWidth="3" strokeLinecap="round"/>
          </svg>
        </div>
        <div className={classes.cardContent}>
          <div className={classes.cardTitleRow}>
            <div className={classes.cardIcon}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
                <polyline points="9 12 11 14 15 10"></polyline>
              </svg>
            </div>
            <Typography variant="h3" className={classes.cardTitle}>
              Your Security. Our Top Priority.
            </Typography>
          </div>
          <div className={classes.cardBody}>
            <Typography component="p">
              We take your privacy seriously. Your data is protected with enterprise-grade encryption and strict security practices.
            </Typography>
            <Typography component="p">
              We never ask for sensitive information like your Social Security Number. Your login credentials are never stored or seen by us, and our read-only access means we can't move money or make changes on your behalf.
            </Typography>
            <Typography component="p">
              You'll always stay in control—we provide recommendations, and you make the final decisions.
            </Typography>
          </div>
        </div>
      </div>

      {/* Bottom Banner */}
      <div className={classes.bottomBanner}>
        <div className={classes.bannerText}>
          <Typography variant="h3">Better planning. Lower fees. Brighter future.</Typography>
          <Typography component="p">Plootus is here to help you take control of your financial future with confidence.</Typography>
        </div>
        <Button 
          variant="contained" 
          className={classes.bannerBtn}
          endIcon={<ArrowForwardIosIcon style={{ fontSize: '14px' }} />}
          href="/auth/signup"
        >
          Get Started Free
        </Button>
      </div>
    </Container>
  );
};

export default OurPhilosophy;
